export enum InventoryRuleTrigger {
  Processed = "processed",
  Scheduled = "scheduled",
  Recurring = "recurring",
}
